module.exports = __webpack_public_path__ + "static/media/picto-tribes.899c9896.svg";